import { createAction, props } from '@ngrx/store';

// Connect Payment
export const getPayment = createAction(
    '[Data] Payment gateway status'
);
export const getPaymentSuccess = createAction(
    '[Data] Payment gateway status success',
    props<{ hasConnect: boolean|null }>()
);
export const getPaymentFailure = createAction(
    '[Data] Payment gateway status failure',
    props<{ error: string }>()
);

// Connect Payment
export const connectPayment = createAction(
    '[Data] Connect payment gateway'
);
export const connectPaymentSuccess = createAction(
    '[Data] Connect payment gateway success',
    props<{connectUrl: string}>()
);
export const connectPaymentFailure = createAction(
    '[Data] Connect payment gateway failure',
    props<{ error: string }>()
);

// Register Payment
export const registerPayment = createAction(
    '[Data] Register payment gateway'
);
export const registerPaymentSuccess = createAction(
    '[Data] Register payment gateway success',
    props<{connectUrl: string}>()
);
export const registerPaymentFailure = createAction(
    '[Data] Register payment gateway failure',
    props<{ error: string }>()
);


// Complete Connection Payment
export const completeConnectionPayment = createAction(
    '[Data] Complete connection payment gateway',
    props<{ data: any }>()
);
export const completeConnectionPaymentSuccess = createAction(
    '[Data] Complete connection payment gateway success'
);
export const completeConnectionPaymentFailure = createAction(
    '[Data] Complete connection payment gateway failure',
    props<{ error: string }>()
);

// Disconnect Payment
export const disconnectPayment = createAction(
    '[Data] Disconnect payment gateway'
);
export const disconnectPaymentSuccess = createAction(
    '[Data] Disconnect payment gateway success'
);
export const disconnectPaymentFailure = createAction(
    '[Data] Disconnect payment gateway failure',
    props<{ error: string }>()
);

//GET COLLECT MASTER
export const getCollectMaster = createAction(
    '[Data] Collect master status'
);
export const getCollectMasterSuccess = createAction(
    '[Data] Collect master status success',
    props<{ hasCollectMaster: boolean|null }>()
);
export const getCollectMasterFailure = createAction(
    '[Data] Collect master status failure',
    props<{ error: string }>()
);

// Connect Collect Master
export const connectCollectMaster = createAction(
    '[Data] Connect collect master'
);
export const connectCollectMasterSuccess = createAction(
    '[Data] Connect collect master success',
);
export const connectCollectMasterFailure = createAction(
    '[Data] Connect collect master failure',
    props<{ error: string }>()
);

// Disconnect Collect Master
export const disconnectCollectMaster = createAction(
    '[Data] Disconnect collect master'
);
export const disconnectCollectMasterSuccess = createAction(
    '[Data] Disconnect collect master success'
);
export const disconnectCollectMasterFailure = createAction(
    '[Data] Disconnect collect master failure',
    props<{ error: string }>()
);


//Reset State
export const resetState = createAction(
    '[Data] reset state payment gateway',
);
